/**
 * The Role of an Editor from lowest to highest
 */
export enum EditorRole {
  Author = 'author',
  Editor = 'editor',
  AppAdmin = 'appAdmin',
  ZAVAdmin = 'zavAdmin'
}

export function getEditorRoleViewValue(role: EditorRole): string {
  switch (role) {
    case EditorRole.Author:
      return 'Autor:in';
    case EditorRole.Editor:
      return 'Redakteur:in';
    case EditorRole.AppAdmin:
      return 'App-Administrierende';
    case EditorRole.ZAVAdmin:
      return 'ZAV-Administrierende';
    default:
      return '';
  }
}
